<template>
  <div class="page-container">
    <h1>在线人数</h1>
    <div class="user-options clearfix">
      <el-select
        style="width: 80px"
        v-model="curChannel.selectValue"
        placeholder=""
      >
        <el-option
          v-for="(item, itemIndex) in channels"
          v-bind:key="itemIndex"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
      <el-date-picker
        v-model="dateValue"
        value-format="yyyy-MM-dd"
        disabledDate="disabledDate"
        type="date"
        :picker-options="pickerOptions"
        placeholder="选择日期"
      >
      </el-date-picker>
      <el-button type="primary" @click="doInQuery">查询</el-button>
    </div>
    <div class="user-options clearfix">
      <el-date-picker
        v-model="datePicked"
        type="daterange"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        value-format="yyyy-MM-dd"
        align="right"
        :unlink-panels="true"
        :picker-options="pickerOptions"
      >
      </el-date-picker>
      <el-time-select
        placeholder="起始时间"
        v-model="startTime"
        :picker-options="{
          start: '00:00',
          step: '00:15',
          end: '23:45',
        }"
      >
      </el-time-select>
      <el-time-select
        placeholder="结束时间"
        v-model="endTime"
        :picker-options="{
          start: '00:15',
          step: '00:15',
          end: '24:00',
          minTime: startTime,
        }"
      >
      </el-time-select>

      <el-button type="primary" @click="downloadReport">下载</el-button>
    </div>
    <div class="display-type">
      <div v-loading="loading">
        <CustomLine :options="lineOptions" class="line"></CustomLine>
      </div>
    </div>
  </div>
</template>

<script>
import CustomLine from '../../components/CustomLine'

export default {
  name: 'UserOnlinePage',
  components: {
    CustomLine
  },
  data() {
    return {
      lineOptions: {
        title: '在线人数',
        legend: [
          '在线人数',
          '在线主播数',
          '主播正在通话数',
          '可以打电话的在线人数',
          '用户正在通话数'
        ],
        xAxis: {
          name: 'UTC时间',
          type: 'category',
          boundaryGap: false,
          data: []
        },
        yAxis: {
          name: '人数',
          type: 'value'
        },
        series: [
          {
            name: '在线人数',
            type: 'line',
            smooth: true,
            data: []
          },
          {
            name: '在线主播数',
            type: 'line',
            smooth: true,
            data: []
          },
          {
            name: '主播正在通话数',
            type: 'line',
            smooth: true,
            data: []
          },
          {
            name: '可以打电话的在线人数',
            type: 'line',
            smooth: true,
            data: []
          },
          {
            name: '用户正在通话数',
            type: 'line',
            smooth: true,
            data: []
          }
        ]
      },
      dateValue: this.$store.getters.dateOneDayBefore,
      activeName: 'line',
      tableList: [],
      loading: true,
      pickerOptions: {
        disabledDate(date) {
          let dateNow = new Date()
          dateNow.setDate(dateNow.getDate())
          if (date.getTime() > dateNow.getTime()) {
            return true
          }
        }
      },
      curChannel: {
        selectValue: 'all',
        content: ''
      },
      channels: this.$store.state.channels,

      datePicked: [
        this.$store.getters.dateOneWeekBefore,
        this.$store.getters.dateOneDayBefore
      ],
      startTime: '18:00',
      endTime: '21:00'
    }
  },
  beforeCreate() {},
  created() {
    this.getList()
  },
  mounted() {},
  computed: {
    username() {
      return this.$store.getters.username
    },
    userLevel() {
      return this.$store.getters.userLevel
    },
    token() {
      return this.$store.getters.token
    }
  },
  watch: {},
  methods: {
    //获取视频通话数据
    getList() {
      this.loading = true
      this.$axios({
        type: 'GET',
        url: this.$store.getters.path.users_query_online_stats,
        withCredentials: true,
        params: {
          username: this.username,
          token: this.token,
          time: this.dateValue,
          channel: this.curChannel.selectValue
        }
      })
        .then(
          res => {
            if (res.data.code === 0) {
              this.lineOptionBuild(res.data.data)
            } else if (res.data.code === 1001) {
              this.$message({
                showClose: true,
                message: res.data.msg,
                type: 'error'
              })
              this.$router.push(this.$route.query.redirect || '/login')
            } else {
              this.$message({
                showClose: true,
                message: res.data.msg,
                type: 'error'
              })
            }
          },
          err => {
            this.$message({
              showClose: true,
              message: '请求错误:' + err,
              type: 'error'
            })
          }
        )
        .then(() => {
          this.loading = false
        })
    },
    // 折线图配置
    lineOptionBuild(data) {
      this.lineOptions.xAxis.data = []
      for (let i = 0; i < this.lineOptions.series.length; i++) {
        this.lineOptions.series[i].data = []
      }
      for (let j in data) {
        if (data.hasOwnProperty(j)) {
          this.lineOptions.xAxis.data.push(data[j].updateTimeStr)
          this.lineOptions.series[0].data.push(data[j].user_count)
          this.lineOptions.series[1].data.push(data[j].gender_count)
          this.lineOptions.series[2].data.push(data[j].gender_calling_count)
          this.lineOptions.series[3].data.push(data[j].user_can_calling_count)
          this.lineOptions.series[4].data.push(data[j].user_calling_count)
        }
      }
    },
    doInQuery() {
      this.getList()
    },
    downloadReport() {
      window.location.href =
        this.$store.getters.path.user_online_download +
        '?token=' +
        this.token +
        '&channel=' +
        this.curChannel.selectValue +
        '&start=' +
        this.datePicked[0] +
        '&end=' +
        this.datePicked[1] +
        '&startTime=' +
        this.startTime +
        '&endTime=' +
        this.endTime +
        '&username=' +
        this.username
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '../../assets/stylus/variable.styl';

.page-container {
  margin-left: 20px;
  margin-top: 20px;

  h1 {
    font-size: 28px;
    font-weight: bold;
  }

  .user-options {
    margin-top: 40px;

    button {
      margin-left: 30px;
    }
  }

  .display-type {
    margin-top: 20px;

    .line {
      width: 1440px;
      height: 700px;
    }
  }
}
</style>
